import * as React from "react";
import { FlagDef } from "./flag-def";

const DutchFlag: FlagDef = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="900"
    height="600"
    {...props}
    viewBox="0 0 9 6"
  >
    <path fill="#21468B" d="M0 0h9v6H0z"></path>
    <path fill="#FFF" d="M0 0h9v4H0z"></path>
    <path fill="#AE1C28" d="M0 0h9v2H0z"></path>
  </svg>
);

export default DutchFlag;
